import { EntityLabels } from '@web-shared/types';

export enum PHOTO_TYPE {
  ORIGINAL = 'original_picture_of_bol',
  ACTUAL = 'actual_picture_of_bol',
}

export const PHOTO_TYPE_LABELS: EntityLabels<PHOTO_TYPE> = {
  [PHOTO_TYPE.ORIGINAL]: 'label_originalPictureOfBol',
  [PHOTO_TYPE.ACTUAL]: 'label_actualPictureOfBol',
} as const;
